import * as React from 'react';
import VersionNumber from '../../../VersionNumber';
import styles from './style.scss';

function RequirePhoneFooter() {
  return (
    <>
      <VersionNumber className={styles.versionNumber} />
    </>
  );
}

export default RequirePhoneFooter;
